import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { setSession } from "@/lib/auth";
import { postWithRetry } from "@/lib/retryPost";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");

    const process = async () => {
      try {
        const { data } = await postWithRetry(
          `${API}/auth/google-session`,
          { session_id: sessionId },
          () => toast.message("RelayRigs is waking up — retrying automatically...")
        );
        setSession(data.user);
        toast.success(`Welcome, ${data.user.name || data.user.email}!`);
      } catch (err) {
        toast.error(err.response?.data?.detail || "Google sign-in failed. Please try again.");
      } finally {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    };

    if (sessionId) {
      process();
    } else {
      navigate("/", { replace: true });
    }
  }, [location.hash, navigate]);

  return null;
}
